import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../contexts/AuthContext"
import { useNavigate } from "react-router-dom";

const Login = () => {
  const { login, savedUsername, autoLogin } = useContext(AuthContext);
  const [username, setUsername] = useState(savedUsername);
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(!!savedUsername);
  const [autoLoginCheck, setAutoLoginCheck] = useState(!!autoLogin);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      await login(username, password, rememberMe, autoLoginCheck);
      navigate("/");
    } catch (err) {
      setError("로그인 실패: 아이디 또는 비밀번호를 확인하세요.");
      console.error(err);
    }
  };


  return (
    <section className="py-5">
      {error && <div className="error">{error}</div>}
      <div className="container px-5">
        <div className="bg-light rounded-4 py-5 px-4 px-md-5">
          <div className="text-center mb-5">
            <img className="mb-4" src="/assets/images/widus-logo.png" alt="" width="100" />
            <h1 className="fw-bolder">로그인</h1>
          </div>
          <div className="row gx-5 justify-content-center">
            <div className="col-lg-8 col-xl-6">
              <form id="contactForm" data-sb-form-api-token="API_TOKEN" onSubmit={handleSubmit}>
                <div className="form-floating mb-3">
                  <input type="text" id="username" className="form-control" name="username" required
                    data-sb-validations="required" value={username} onChange={(e) => setUsername(e.target.value)} />
                  <label htmlFor="username">아이디</label>
                  <div className="invalid-feedback" data-sb-feedback="username:required">A username is required.</div>
                </div>
                <div className="form-floating mb-3">
                  <input type="password" id="password" className="form-control" name="password" required
                    data-sb-validations="required,password" value={password} onChange={(e) => setPassword(e.target.value)} />
                  <label htmlFor="password">비밀번호</label>
                  <div className="invalid-feedback" data-sb-feedback="password:required">An password is required.</div>
                </div>
                <div className="d-none" id="submitSuccessMessage">
                  <div className="text-center mb-3">
                    <div className="fw-bolder">Form submission successful!</div>
                  </div>
                </div>
                <div className="d-none" id="submitErrorMessage">
                  <div className="text-center text-danger mb-3">Error sending message!</div>
                </div>
                <div className="checkbox mb-4">
                  <input type="checkbox" id="rememberMe" className="form-check-input" name="rememberMe"
                    checked={rememberMe} onChange={() => setRememberMe(!rememberMe)} />
                  <label htmlFor="rememberMe" className="form-check-label">아이디 저장</label>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <input type="checkbox" id="autoLogin" className="form-check-input" name="autoLogin"
                    checked={autoLoginCheck} onChange={() => setAutoLoginCheck(!autoLoginCheck)} />
                  <label htmlFor="rememberMe" className="form-check-label">자동 로그인</label>
                </div>
                <div className="d-grid"><button className="btn btn-primary btn-lg" id="submitButton" type="submit" >로그인</button>
                </div>
                <div className="mt-4 text-center">
                  <a href="register">회원가입</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Login;
